export default __webpack_public_path__ + "static/media/readme.dec7f20b.png";